import { Observable, tap, shareReplay } from 'rxjs';

/**
 * An util to wrap a stream that returns basically the same stream, but it lets
 * you pass in a callback which will be called on the first subscription.
 * Typical use case is a non-persistent stream which requires some
 * initialization to build the start state, e.g. fetching a resource or just
 * feeding initial state built at the moment of subscription. This can replace
 * what is often done in e.g. useEffect.
 *
 * @param observable
 * @param callback
 * @returns observable |
 */

export const withOnFirstSubscription = <T>(
  observable: Observable<T>,
  callback: () => void
) => {
  return observable.pipe(
    tap({
      subscribe: () => {
        // It's good practice to dispatch any action which could affect the stream
        // we are dealing with asynchronously. Doing it synchronously can lead to
        // very unexpected behavior
        // (e.g. like this https://chriskr.github.io/test-rxjs/). It's very likely
        // that the callback is affecting the subscribe stream directly here,
        // that's after all the main purpose of the callback.
        setTimeout(callback);
      },
    }),
    shareReplay({ refCount: true, bufferSize: 1 })
  );
};
